import { __read, __spreadArray } from "tslib";
import { concat } from './concat';
export function concatWith() {
    var otherSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        otherSources[_i] = arguments[_i];
    }
    return concat.apply(void 0, __spreadArray([], __read(otherSources)));
}
//# sourceMappingURL=concatWith.js.map